import axios from 'axios';
import { apiURL } from './url/url';

const api = axios.create({
    baseURL:apiURL
})

api.interceptors.request.use(
    (config)=>{
        const token=sessionStorage.getItem('token');
        if(token){
            config.headers.Authorization=`Bearer ${token}`;  
        }
        return config;
    },
    (error) => Promise.reject(error)
)

export default api
